﻿<script>
  import { getContext } from "svelte";
  import Plus from "../Vectors/Plus.svelte";
  import LanguageTextEdit from "./LanguageTextEdit.svelte";
  import CustomSelectBox from "../SharedComponents/CustomSelectBox.svelte";
  import { fade } from "svelte/transition";
  import { navigate } from "svelte-routing";

  import { languageTextsStore } from "../store/languageTexts.js";
  import { languageFilterStore } from "../store/languageFilter.js";
  import { countryStore } from "../store/Countries";

  const { open } = getContext("modal");
  const { snackbar } = getContext("app");

  let langTextFilterCountryVersion = -1;
  let countryVersions = [];

  let languageTextId = "";

  updateLangText();
  function AddLanguageText() {
    open(LanguageTextEdit, null);
  }

  async function updateLangText() {
    await languageTextsStore.getLanguageTextsFiltered();
  }

  let files;
  async function UploadFile() {
    let thefile = files[0];
    try {
      uploading = true;
      var ret = await languageTextsStore.import(thefile);
      langTextFilterCountryVersion = langTextFilterCountryVersion;
      if (ret.success) {
        snackbar("success", "file uploaded succesfully");
      } else {
        snackbar("error", ret.message);
      }
    } catch (s) {
      snackbar(
        "error",
        "The upload failed, please make sure you are using the multilingual          JSON format (not I11)"
      );
    }
    uploading = false;
  }

  let uploading = false;
  let filesexcel;
  async function UploadExcelFile() {
    let thefile = filesexcel[0];
    try {
      uploading = true;
      var ret = await languageTextsStore.importExcel(thefile);
      langTextFilterCountryVersion = langTextFilterCountryVersion;
      if (ret.success) {
        snackbar("success", "file uploaded succesfully");
      } else {
        snackbar("error", ret.message);
      }
    } catch (s) {
      snackbar(
        "error",
        "The upload failed, please make sure you are using the correct excel file as downloaded"
      );
    }
    uploading = false;
    await languageTextsStore.getLanguageTextsFiltered();
  }
  function EditLanguageText(languageText) {
    open(LanguageTextEdit, {
      id: languageText.langKey,
      langTextFilterCountryVersion,
    });
    // navigate("/app/languagetext/" + languageText.langKey);
  }

  function GetText(lang, key) {
    if (!lang || lang == undefined || lang == null) return "";
    if (!key || key == undefined || key == null) return "";
    var ret = key.langTexts.find((lt) => lt.langName == lang);
    if (ret != null) return ret.langValue;
    return "";
  }

  let activeLangs = ["nl", "en"];
  function GetShortText(lang, key) {
    var ret = GetText(lang, key);
    if (ret.length > 100) {
      ret = ret.substring(0, 100) + "...";
    }
    return ret;
  }
  $: textFilter = $languageFilterStore;
  $: filteredKeys = GetFilteredKeys(
    $languageTextsStore.allKeys,
    textFilter,
    langTextFilterCountryVersion
  );

  function GetFilteredKeys(keys, filter) {
    if (!keys || keys == undefined || keys == null) return [];

    var filterWords = filter.toLowerCase().split(" ");
    return keys.filter(
      (a) =>
        (a.langKey &&
          filterWords.every((fw) => a.langKey.toLowerCase().includes(fw))) ||
        a.langTexts.some(
          (lt) =>
            lt.langValue && filterWords.every((fw) => lt.langValue.includes(fw))
        )
    );
  }

  async function ReloadTextsOnSite() {
    var respo = await languageTextsStore.reloadOnSite();
    if (respo.success) {
      snackbar("success", respo.message);
    } else {
      snackbar("error", respo.message);
    }
  }

  // let fileuploader;
  // let fileuploaderExcel;
  // let showSuccess = false;
  // let showError = false;
  // function choosefile() {
  //   fileuploader.click();
  // }
  // function choosefile2() {
  //   fileuploaderExcel.click();
  // }
  async function deleteLangItem(item) {
    await languageTextsStore.deleteLangItem(item.langKey);
    return false;
  }

  async function getCountryVersions() {
    countryVersions = await countryStore.getCountryVersions();
  }
  getCountryVersions();

  let exportLang = "dutch";
  let languages = [];
  async function loadLangs() {
    languages = await languageTextsStore.getLangs();
  }
  loadLangs();
  async function downloadExcel() {
    await languageTextsStore.downloadExcel(exportLang);
  }
</script>

{#if $languageTextsStore && $languageTextsStore.allKeys}
  
  <div style="float:right;width:400px;">
    <div style="float:right" class="p-2 mr-0 bg-info d-inline-block rounded text-white ">
      <button class="btn btn-secondary button-excel" style="float:right;margin-left:3px" on:click={downloadExcel}
        >Download</button>
      <div style=" color:#000 !important; max-width: 200px;">
        <CustomSelectBox style="display: inline-block;float:right;"
          items={languages.map((s) => {
            return { key: s, value: s };
          })}
          bind:value={exportLang}
        />
      </div>
      <hr style="    border-top: 1px solid rgba(255, 255, 255, 0.4);" />
      <div id="upload-container">
        Upload:
        <div style="display: inline-block; width: 100px; height: 30px; overflow:hidden;">
          <div style="display:inline-block;width: 120px; height: 40px; position:relative; top: 10px; left: 0px;text-decoration:underline;cursor:pointer">
            {#if filesexcel}{filesexcel[0].name}{:else}Choose file{/if}
          </div>
          <input
            type="file"
            id="uploadexcel_input"
            bind:files={filesexcel}
            name="uploadExcel"
            style="font-size: 50px; width: 120px; opacity: 0;
          filter:alpha(opacity=0); position: relative; top: -40px;; left: -20px; cursor:pointer !important;"
            title="Use multilingual JSON format"
          />
        </div>
        {#if uploading}
          <div>uploading now please wait...</div>
        {:else}
          <button  class="btn btn-secondary button-excel" on:click={UploadExcelFile}>Upload</button>
        {/if}
      </div>
    </div>
  </div>
  <!-- <div
    style="float:right"
    class="p-2 pr-3 pl-3 mr-3 bg-info d-inline-block rounded text-white "
  >
    <a href="/api/lang/export" title="Export for OneSky">
      <img
        alt="One Sky logo"
        src="/img/onesky_logo-white.png"
        style="max-height: 30px;"
        class="mr-1"
      />
      <span class="ml-2 " style="top:-5px;">Download</span>
    </a>
    | Upload :
    <div
      style="display: inline-block; width: 100px; height: 30px; overflow:
    hidden;"
    >
      <div
        style="display:inline-block;width: 120px; height: 40px; position:
      relative; top: 10px; left:
      0px;text-decoration:underline;cursor:pointer"
      >
        {#if files}{files[0].name}{:else}Choose file{/if}
      </div>
      <input
        type="file"
        id="upload_input"
        bind:files
        name="upload"
        style="font-size: 50px; width: 120px; opacity: 0;
      filter:alpha(opacity=0); position: relative; top: -40px;; left: -20px"
        title="Use multilingual JSON format"
      />
    </div>
    {#if uploading}
      <div>uploading now please wait...</div>
    {:else}
      <button on:click={UploadFile}>Upload</button>
    {/if}
  </div> -->

  <div class="float-left">
    <h2 class="text-primary" style="display:block;width:100%">
      Language texts
      <Plus on:click={AddLanguageText} />
    </h2>
    
  </div>
  <br clear="both" />

  <div class="">
    <div style="float:right;margin-top:10px">
      <br />
      <input
        type="button"
        class="btn btn-primary pr-4 pl-4"
        on:click={ReloadTextsOnSite}
        value="Reload texts on site"
      />
    </div>
    <input
      style="width:400px"
      class="mr-3 p-2"
      placeholder="filter on keyword"
      type="text"
      bind:value={$languageFilterStore}
    />

    <div style="margin-top:10px">
      {#each $languageTextsStore.allLangs.filter((l) => l != null) as lang}
        <input
          type="checkbox"
          bind:group={activeLangs}
          id="chck{lang}"
          value={lang}
        />
        <label style="margin-right:10px" for="chck{lang}">{lang}</label>
      {/each}
    </div>
   
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-sm list fold-out mt-3">
      <thead>
        <tr>
          <th>Naam</th>
          {#each $languageTextsStore.allLangs as lang}
            {#if activeLangs.indexOf(lang) > -1}
              <th>{lang}</th>
            {/if}
          {/each}
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        {#each filteredKeys as key}
          <tr in:fade={{ duration: 800 }} on:click={EditLanguageText(key)}>
            <th>{key.langKey}</th>
            {#each $languageTextsStore.allLangs as lang}
              {#if activeLangs.indexOf(lang) > -1}
                <td title={GetText(lang, key)}>{GetShortText(lang, key)}</td>
              {/if}
            {/each}
            <td>
              <button
                class="btn btn-secondary"
                on:click|stopPropagation={() => deleteLangItem(key)}
                >delete</button
              >
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
{/if}

<style>
:global(.selectContainer) {
  height: 36px !important;
}

.button-excel {
  width:105px;
}

#upload-container {
  margin-top:-7px;
}
#file-upload-button {
  cursor:pointer !important;
}

</style>